{
  "title": "Messages",
  "nav": {
    "label": "Messages",
    "unread": "{{unreadValue}} unread message(s)"
  },
  "list": {
    "empty": "You have no conversations yet.",
    "includeArchived": "Show archived",
    "noMessage": "No message yet.",
    "unknownParticipant": "Deleted account"
  },
  "thread": {
    "empty": "Write the first message of this conversation."
  },
  "search": {
    "label": "Search this conversation",
    "placeholder": "A word from the message…",
    "results_one": "{{count}} message found",
    "results_other": "{{count}} messages found",
    "empty": "No message contains “{{query}}”."
  },
  "message": {
    "deleted": "Message deleted",
    "edited": "edited",
    "delete": "Delete",
    "report": "Report",
    "hidden": "Message removed by moderation"
  },
  "link": {
    "title": "External link",
    "destination": "This link leaves Teach for {{host}}.",
    "open": "Open the link",
    "cancel": "Cancel"
  },
  "composer": {
    "label": "Your message",
    "placeholder": "Write a message…",
    "send": "Send",
    "closed": "This conversation is read-only: no enrolment links you to this person any more."
  },
  "actions": {
    "mute": "Mute",
    "unmute": "Unmute",
    "archive": "Archive",
    "unarchive": "Unarchive"
  }
}
